module.exports = __webpack_public_path__ + "img/co2_en.b230fb97.jpg";